import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelSettingsCompetitorsBenchmarkCompsetBuilderRoute from 'lumen/routes/hotel/settings/competitors/benchmark/compset/builder';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsCompetitorsBenchmarkCompsetBuilderReviewRoute extends Route {
  @service('benchmark-insight/competitors/compset')
  declare benchmarkInsightCompetitorsCompset: Services['benchmark-insight/competitors/compset'];

  @service declare router: Services['router'];

  beforeModel(): void {
    if (!this.benchmarkInsightCompetitorsCompset.selectedProposedCompset) {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.router.legacyTransitionTo(
        'hotel.settings.competitors.benchmark.compset.builder.proposals',
      );
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  model() {
    const parentModel = this.modelFor(
      'hotel.settings.competitors.benchmark.compset.builder',
    ) as ModelFrom<HotelSettingsCompetitorsBenchmarkCompsetBuilderRoute>;

    return parentModel;
  }
}
